import { useCallback, useState } from "react";
import { isCompletedStatus } from "../utils/taskUtils";

/**
 * Opens the task drawer/details and increments a signal so WorkLogPanel
 * switches to the Work Log tab and opens Log Work Time after Completed status.
 */
export function useWorkLogPrompt() {
  const [workLogOpenSignal, setWorkLogOpenSignal] = useState(0);

  const promptWorkLogIfCompleted = useCallback((task, newStatus, onOpenTask) => {
    if (!isCompletedStatus(newStatus) || !task?.id) return false;
    onOpenTask?.(task);
    setWorkLogOpenSignal((signal) => signal + 1);
    return true;
  }, []);

  const resetWorkLogSignal = useCallback(() => {
    setWorkLogOpenSignal(0);
  }, []);

  return { workLogOpenSignal, promptWorkLogIfCompleted, resetWorkLogSignal };
}
